"use client"

import { useState, useEffect } from "react"
import { RefreshCw } from "lucide-react"
import { Button } from "@/components/ui/button"

export function PWAUpdateBanner() {
  const [showUpdate, setShowUpdate] = useState(false)

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return

    // Écouter quand un nouveau SW prend le contrôle
    let refreshing = false
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return
      refreshing = true
      window.location.reload()
    })

    // Vérifier une seule fois à l'ouverture de l'app
    navigator.serviceWorker.ready.then((registration) => {
      registration.update()

      function onUpdateFound() {
        const newWorker = registration.installing
        if (!newWorker) return

        newWorker.addEventListener("statechange", () => {
          if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
            setShowUpdate(true)
          }
        })
      }

      registration.addEventListener("updatefound", onUpdateFound)

      if (registration.waiting && navigator.serviceWorker.controller) {
        setShowUpdate(true)
      }
    })
  }, [])

  function handleUpdate() {
    navigator.serviceWorker.ready.then((registration) => {
      registration.waiting?.postMessage({ type: "SKIP_WAITING" })
    })
  }

  if (!showUpdate) return null

  return (
    <div className="fixed top-0 inset-x-0 z-50 p-3 sm:p-4">
      <div className="mx-auto max-w-lg rounded-xl bg-primary text-white shadow-lg px-4 py-3 flex items-center gap-3">
        <RefreshCw className="size-5 shrink-0" />
        <p className="text-sm flex-1">Une nouvelle version est disponible</p>
        <Button
          onClick={handleUpdate}
          size="sm"
          variant="secondary"
          className="shrink-0"
        >
          Mettre à jour
        </Button>
      </div>
    </div>
  )
}
